/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ spacing: { unit } }) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: [6.25 * unit, 6.25 * unit]
  }
}));
